import { useNaptime } from 'bundles/naptimejs';
import SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';

export type PropsFromUseGetSubscriptionById = {
  subscription: SubscriptionsV1;
  pending?: boolean;
};

export const useGetSubscriptionById = ({ subscriptionId }: { subscriptionId?: string }) => {
  const {
    data: { subscription },
    pending,
  } = useNaptime<{ subscription: SubscriptionsV1 }>(() => {
    if (!subscriptionId) {
      return { subscription: null };
    }

    return {
      subscription: SubscriptionsV1.get(subscriptionId, {
        fields: [
          'cartId',
          'id',
          'isActive',
          'nextBillingAt',
          'productItemId',
          'productType',
          'status',
          'productSku',
          'paymentInformation',
          'paymentProcessorId',
        ],
      }),
    };
  }, [subscriptionId]);

  return { subscription, pending };
};
